import React, { useState, useEffect } from 'react';
import clsx from 'clsx';

export interface ITextFilter {
    filter: any;
    onFilterChange: (filterId: number, value: any, debounced?: boolean) => void;
    className?: string;
}

export const TextFilter: React.FC<ITextFilter> = (props): JSX.Element => {
    const { filter, onFilterChange, className } = props;
    const [ value, setValue ] = useState('');
    const handleChange = (evt) => {
        setValue(evt.target.value);
        onFilterChange(
            filter.id,
            evt.target.value,
            true
        );
    };

    useEffect(() => {
        if (!filter.value) {
            setValue('');
        }
    }, [ filter.value ]);

    useEffect(() => {
        setValue(filter.value);
        return () => {};
    }, []);

    return (
        <div className={clsx('objects-filter', 'objects-filter-text', className)}>
            <div className="objects-filter__name">{ filter.name }</div>
            <div className="objects-filter-text__control">
                <input type="text" value={value} onChange={handleChange} />
            </div>
        </div>
    );
};
